import { useState } from "react";
import { useAuditLog } from "../../hooks/useAdmin";
import Card from "../../components/ui/Card";
import Badge from "../../components/ui/Badge";
import Button from "../../components/ui/Button";

const typeIcon  = (t:string) => t==="kyc"?"🪪":t==="loan"?"🤝":t==="alert"?"⚠️":t==="member"?"👤":"🛡️";
const typeColor = (t:string):any => t==="kyc"?"blue":t==="loan"?"emerald":t==="alert"?"red":t==="member"?"slate":"violet";

export default function AdminActivityPage() {
  const [filter, setFilter] = useState("all");
  const { data: logs = [], isLoading } = useAuditLog({ limit:50 }) as any;

  const filtered = filter==="all" ? logs : logs.filter((l:any)=>l.target_type===filter);

  return (
    <div>
      <div className="flex gap-2 mb-5 flex-wrap">
        {["all","user","loan","kyc"].map(f=>(
          <Button key={f} size="sm" variant={filter===f?"primary":"secondary"} onClick={()=>setFilter(f)}>
            {f.charAt(0).toUpperCase()+f.slice(1)}
          </Button>
        ))}
      </div>
      <Card>
        <p className="text-sm font-medium text-slate-700 mb-4">Admin audit trail</p>
        {isLoading ? (
          <p className="text-sm text-slate-400 text-center py-6">Loading audit log…</p>
        ) : filtered.length === 0 ? (
          <p className="text-sm text-slate-400 text-center py-6">No entries found</p>
        ) : (
          <div className="relative">
            <div className="absolute left-[18px] top-0 bottom-0 w-px bg-slate-100"/>
            {filtered.map((log:any, i:number) => (
              <div key={log.id} className="flex gap-4 pb-5 relative">
                <div className="w-9 h-9 rounded-full bg-slate-50 border border-slate-200 flex items-center justify-center text-lg flex-shrink-0 z-10">
                  {typeIcon(log.target_type||"")}
                </div>
                <div className="flex-1 pt-1.5">
                  <div className="flex justify-between items-start gap-2">
                    <div>
                      <p className="text-sm font-medium text-slate-800">{log.action}</p>
                      <p className="text-xs text-slate-400 mt-0.5">
                        <span className="text-slate-600">{log.admin_name}</span>
                        {log.target_type && ` → ${log.target_type} ${log.target_id?.slice(0,8)||""}`}
                      </p>
                    </div>
                    <div className="flex items-center gap-2 flex-shrink-0">
                      <Badge label={log.target_type||"system"} color={typeColor(log.target_type||"")}/>
                      <span className="text-xs text-slate-400">
                        {new Date(log.created_at).toLocaleString("en-US",{month:"short",day:"numeric",hour:"2-digit",minute:"2-digit"})}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </Card>
    </div>
  );
}
